import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=77317bfd&scoped=true"
import script from "./SplashScreen.vue?vue&type=script&lang=js"
export * from "./SplashScreen.vue?vue&type=script&lang=js"
import style0 from "./SplashScreen.vue?vue&type=style&index=0&id=77317bfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77317bfd",
  null
  
)

export default component.exports